import { createContext, useContext, useMemo, useState } from "react";

import {
  getthirdpartyData,
  thirdpartyUpdate,
} from "../services/thirdpartyService";

const defaultThirdParty = {
  crmSettings: {
    crmProvider: "unassigned",
  },
  calendarSettings: {
    acuitySettings: {
      apiKey: "",
      appointmentTypeId: "",
      calendarId: "",
      userId: "",
      backupDetails: {
        firstName: "",
        lastName: "",
        email: "",
        countryCode: "",
      },
    },
    calDotComSettings: {
      apiKey: "",
      backupDetails: {
        firstName: "",
        lastName: "",
        email: "",
        countryCode: "",
      },
      eventTypeId: "",
    },
    ghlCalendarSettings: {
      appoitmentName: "",
      calendarId: "",
    },
  },
  telephonySettings: {
    telephonyProvider: "",
    twilioSettings: {
      twilioAccountSID: "",
      twilioAuthToken: "",
      phoneNumbers: [],
    },
    plivoSettings: {
      authId: "",
      authToken: "",
      phoneNumbers: [],
    },
    mcubeSettings: {
      callCreationUrl: "",
      callEndUrl: "",
      authToken: "",
      phoneNumbers: [],
    },
    cloudonixSettings: {
      domainId: "",
      customerId: "",
      apiKey: "",
      phoneNumbers: [],
    },
    exotelSettings: {
      apiKey: "",
      apiToken: "",
      accountSid: "",
      phoneNumbers: [""],
      subdomain: "",
      voiceBotAppId: "",
    },
  },
};

const ThirdPartyContext = createContext({});

export function useThirdPartyContext() {
  return useContext(ThirdPartyContext);
}

export default function ThirdPartyProvider({ children }) {
  const [thirdpartyData, setThirdpartyData] = useState(defaultThirdParty);
  const [isThirdPartyLoading, setIsThirdPartyLoading] = useState(true);

  async function fetchThirdpartyData(workspaceId) {
    setIsThirdPartyLoading(true);

    try {
      const response = await getthirdpartyData(workspaceId);

      if (response.status === 200) {
        const data = response.data;

        setThirdpartyData((prevData) => {
          return {
            crmSettings: data.crmSettings,
            calendarSettings: {
              ...defaultThirdParty.calendarSettings,
              ...data.calendarSettings,
            },
            telephonySettings: {
              ...defaultThirdParty.telephonySettings,
              ...data.telephonySettings,
            },
          };
        });
        setIsThirdPartyLoading(false);
      }
    } catch (e) {
      setIsThirdPartyLoading(false);
      setThirdpartyData(defaultThirdParty);
    }
  }

  async function updateThirdpartyData(payload, workspaceId, lifecycleCbs) {
    lifecycleCbs.init();

    try {
      const response = await thirdpartyUpdate(payload, workspaceId);

      if (response.status === 200) {
        lifecycleCbs.success();
        fetchThirdpartyData(workspaceId);
      }
    } catch (e) {
      lifecycleCbs.error(e);
    }
  }

  const value = useMemo(() => {
    return {
      thirdpartyData,
      fetchThirdpartyData,
      updateThirdpartyData,
      isThirdPartyLoading,
    };
  }, [thirdpartyData, isThirdPartyLoading]);

  return (
    <ThirdPartyContext.Provider value={value}>
      {children}
    </ThirdPartyContext.Provider>
  );
}
